<template>
  <div :class="{ 'warning-box': showWarning }" class="page-footer">
    <span>{{ version }}</span>
    <span class="environment" v-if="showWarning">{{ warning }}</span>
    <!-- Dummy for proper centering -->
    <span v-if="showWarning">{{ version }}</span>
  </div>
  <div class="footer-space"></div>
</template>

<script setup lang="ts">
  defineProps<{
    showWarning: boolean;
    version: string;
    warning: string | undefined;
  }>();
</script>

<style scoped lang="scss">
  $margin-horizontal: 0.5rem;

  .page-footer {
    position: fixed;
    bottom: 0;
    color: #999999;
    font-size: 0.6rem;
    margin: 1em $margin-horizontal 0.5rem $margin-horizontal;
    width: calc(100% - 2 * $margin-horizontal);

    display: flex;
    justify-content: space-between;
    column-gap: 1rem;

    &.warning-box span {
      &.environment {
        flex-grow: 1;
      }

      &:not(.environment) {
        flex-shrink: 0;
      }

      &:last-of-type:not(:only-of-type) {
        visibility: hidden;
      }

      @media only screen and (max-width: 600px) {
        &:last-of-type:not(:only-of-type) {
          display: none;
        }
      }
    }
  }

  .footer-space {
    min-height: 2.3rem;

    @media only screen and (max-width: 420px) {
      min-height: 3.3rem;
    }
  }

  .warning-box {
    border: solid 2px rgba(#ffa500, 0.4);
    background-color: rgba(#f5deb3, 0.9);
    padding: 0.3em;

    .environment {
      color: #222;
      font-size: 1.5em;
      text-align: center;
    }
  }
</style>
